export const cleanMask = (maskedPhone: string) => {
  return maskedPhone
    .replace(/-/g, '')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/\s/g, '')
    .replace(/\+/g, '');
};
